module.exports = __webpack_public_path__ + "img/loginhead.1641520899224.png";